import React from 'react'

import { Script } from 'gatsby'

const ThirdPartyScripts = () => (
  <>
    <Script
      dangerouslySetInnerHTML={{
        __html: `
              // Initialize the data layer for Google Tag Manager (this should mandatorily
              // be done before the Privacy Controls and Cookie Solution is loaded)
              window.dataLayer = window.dataLayer || [];
              function gtag() {
                  dataLayer.push(arguments);
              }

              // Set default consent to denied
              gtag("consent", "default", {
                  ad_storage: "denied",
                  analytics_storage: "denied",
                  wait_for_update: 2000
              });

              gtag('set', 'url_passthrough', true);
              // gtag('js', new Date());
              // gtag('config', 'UA-107630400-1');

              // Google Tag Manager
              (function(w, d, s, l, i) {
                  w[l] = w[l] || [];
                  w[l].push({
                      'gtm.start': new Date().getTime(),
                      event: 'gtm.js'
                  });
                  var f = d.getElementsByTagName(s)[0],
                      j = d.createElement(s),
                      dl = l != 'dataLayer' ? '&l=' + l : '';
                  j.async = true;
                  j.src =
                      'https://www.googletagmanager.com/gtm.js?id=' + i + dl;
                  f.parentNode.insertBefore(j, f);
              })(window, document, 'script', 'dataLayer', 'GTM-W673X2W');
            `
      }}
    ></Script>
    <Script
      dangerouslySetInnerHTML={{
        __html: `var _iub = _iub || [];
            _iub.csConfiguration = {
              "countryDetection": true,
              "enableRemoteConsent": true,
              "enableUspr": true,
              "gdprAppliesGlobally": false,
              "usprPurposes":"s",
              // "usprPurposes":"s,sh,adv",
              "lang": "en",
              "perPurposeConsent": true,
              // "reloadOnConsent": false,
              "siteId": 1225976,
              "cookiePolicyId": 13410267,
              "privacyPolicyUrl": "/privacy/",
              "cookiePolicyInOtherWindow": true,
              "banner": {
                "acceptButtonColor": "#1b1b1e",
                "acceptButtonDisplay": true,
                "backgroundColor": "#FFFFFF",
                "brandBackgroundColor": "#FFFFFF",
                "brandTextColor": "#000000",
                "closeButtonDisplay": false,
                "customizeButtonCaptionColor": "#1b1b1e",
                "customizeButtonColor": "#FFFFFF",
                "customizeButtonDisplay": true,
                "explicitWithdrawal": true,
                "fontSizeBody": "12px",
                "listPurposes": false,
                "logo": "https://images.ctfassets.net/hjneo4qi4goj/33l3kWmPd9vgl1WH3m9Jsq/13861635730a1b8af383a8be8932f1d6/flatfile-black.svg",
                "linksColor": "#070707",
                "ownerName": "Flatfile",
                "position": "float-bottom-left",
                "rejectButtonCaptionColor": "#1b1b1e",
                "rejectButtonColor": "#EFEFEF",
                "rejectButtonDisplay": true,
                "showPurposesToggles": false,
                "slideDown": false,
                "textColor": "#1b1b1e",
                "usesThirdParties": false
              },
              "callback": {
                onPreferenceExpressedOrNotNeeded: function (preference) {
                  dataLayer.push({
                    iubenda_uspr_s_opted_out: _iub.cs.api.getPreferences().uspr.s,
                  });
                  // console.log('onPreferenceExpressedOrNotNeeded - iubenda_uspr_s_opted_out: ' + _iub.cs.api.getPreferences().uspr.s);

                  // preferences parameter may be undefined if both GDPR and LGPD do not apply
                  // we may need the line below to find USPR preferences instead of relying
                  // on preferences parameter
                  var otherPreferences = _iub.cs.api.getPreferences();
                  if (otherPreferences) {
                    var usprPreferences = otherPreferences.uspr;
                    if (usprPreferences) {
                      for (var purposeName in usprPreferences) {
                        if (usprPreferences[purposeName]) {
                          dataLayer.push({
                            event: 'iubenda_consent_given_purpose_' + purposeName,
                          });
                          // console.log('otherPreferences - Purpose ' + purposeName + ' given');

                          // if purposename is "s" then do datalayer push to set iubenda_ccpa_opted_out to false

                          // if (purposeName === "s") {
                          //   dataLayer.push({
                          //     iubenda_ccpa_opted_out: false,
                          //   });
                          // }
                        }
                      }
                    }
                  }
                  if (!preference) {
                    dataLayer.push({
                      event: 'iubenda_preference_not_needed',
                    });
                    // console.log('Preference not needed');
                  }
                  else if (preference.consent === true) {
                    dataLayer.push({
                      event: 'iubenda_consent_given',
                    });
                    // if (window.posthog) {
                    //   posthog.opt_in_capturing();
                    // }
                    // console.log('Consent given');
                  }
                  else if (preference.consent === false) {
                    dataLayer.push({
                      event: 'iubenda_consent_rejected',
                    });
                    window.VWO = window.VWO || [];
                    window.VWO.push(['optOutVisitor']);
                    console.log('Consent rejected');
                    // if (window.posthog) {
                    //   posthog.opt_out_capturing();
                    // }
                  }
                  else if (preference.purposes) {
                    for (var purposeId in preference.purposes) {
                      if (preference.purposes[purposeId]) {
                        dataLayer.push({
                          event: 'iubenda_consent_given_purpose_' + purposeId,
                        });
                        // console.log('preference.purposes - Purpose ' + purposeId + ' given');
                      }
                    }
                  }
                }
              }
            };`
      }}
      type='text/javascript'
    ></Script>

    <Script
      type='text/javascript'
      src='//cs.iubenda.com/sync/1225976.js'
    ></Script>

    <Script
      type='text/javascript'
      src='//cdn.iubenda.com/cs/gpp/stub.js'
    ></Script>

    <Script
      async
      type='text/javascript'
      src='//cdn.iubenda.com/cs/iubenda_cs.js'
      charset='UTF-8'
    ></Script>

    <Script
      data-domain='flatfile.com'
      defer
      src='https://plausible.io/js/plausible.js'
    ></Script>

    <Script
      crossOrigin='anonymous'
      defer
      src='https://kit.fontawesome.com/3913274330.js'
    ></Script>
  </>
)

export default ThirdPartyScripts
